"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminDeletePage = void 0;
const Log_1 = __importDefault(require("@common/Log"));
const UI_1 = require("../util/UI");
const AdminDeliverablesTab_1 = require("./AdminDeliverablesTab");
const AdminPage_1 = require("./AdminPage");
const AdminResultsTab_1 = require("./AdminResultsTab");
const AdminTeamsTab_1 = require("./AdminTeamsTab");
const AdminView_1 = require("./AdminView");
class AdminDeletePage extends AdminPage_1.AdminPage {
    constructor(remote) {
        super(remote);
    }
    init(opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const that = this;
            Log_1.default.info("AdminDeletePage::init(..) - start");
            UI_1.UI.showModal("Retrieving deliverables, repositories and teams.");
            this.deliverables = (yield AdminDeliverablesTab_1.AdminDeliverablesTab.getDeliverables(this.remote)).sort((a, b) => a.id.localeCompare(b.id));
            this.teams = yield AdminTeamsTab_1.AdminTeamsTab.getTeams(this.remote);
            this.repos = yield AdminResultsTab_1.AdminResultsTab.getRepositories(this.remote);
            this.teams = this.teams.sort(function compare(a, b) {
                return a.id.localeCompare(b.id);
            });
            this.repos = this.repos.sort(function compare(a, b) {
                return a.id.localeCompare(b.id);
            });
            const delivDelete = document.getElementById("deliverableDeleteSelect");
            delivDelete.innerHTML = "";
            for (const deliv of this.deliverables) {
                const option = document.createElement("option");
                option.text = deliv.id;
                delivDelete.add(option);
            }
            const teamDelete = document.getElementById("teamDeleteSelect");
            teamDelete.innerHTML = "";
            for (const team of this.teams) {
                const option = document.createElement("option");
                option.text = team.id;
                teamDelete.add(option);
            }
            const repoDelete = document.getElementById("repoDeleteSelect");
            repoDelete.innerHTML = "";
            for (const repo of this.repos) {
                const option = document.createElement("option");
                option.text = repo.id;
                repoDelete.add(option);
            }
            UI_1.UI.hideModal();
            document.querySelector("#adminDeleteDeliverableButton").onclick = function (evt) {
                Log_1.default.info("AdminDeletePage::handleDeliverableDelete(..) - delete pressed");
                evt.stopPropagation();
                that
                    .deleteDeliverablesPressed()
                    .then(function () {
                })
                    .catch(function (err) {
                    Log_1.default.error("AdminDeletePage::handleDeliverableDelete(..) - delete pressed ERROR: " + err.message);
                });
            };
            document.querySelector("#adminDeleteTeamButton").onclick = function (evt) {
                Log_1.default.info("AdminDeletePage::handleTeamDelete(..) - button pressed");
                evt.stopPropagation();
                that
                    .deleteTeamPressed()
                    .then(function () {
                })
                    .catch(function (err) {
                });
            };
            document.querySelector("#adminDeleteRepositoryButton").onclick = function (evt) {
                Log_1.default.info("AdminDeletePage::handleRepositoryDelete(..) - button pressed");
                evt.stopPropagation();
                that
                    .deleteRepoPressed()
                    .then(function () {
                })
                    .catch(function (err) {
                });
            };
            document.querySelector("#adminDeleteSanitizeDB").onclick = function (evt) {
                Log_1.default.info("AdminDeletePage::adminDeleteSanitizeDB(..) - button pressed");
                evt.stopPropagation();
                that
                    .sanitizeDBPressed()
                    .then(function () {
                })
                    .catch(function (err) {
                });
            };
        });
    }
    deleteRepoPressed() {
        return __awaiter(this, void 0, void 0, function* () {
            const repoDelete = document.getElementById("repoDeleteSelect");
            const selected = [];
            for (const opt of repoDelete.options) {
                if (opt.selected) {
                    selected.push(opt.value || opt.text);
                }
            }
            Log_1.default.info("AdminDeletePage::deleteRepoPressed(..) - start; # repos to delete: " + selected.length);
            if (selected.length > 0) {
                UI_1.UI.showSuccessToast("Repository deletion in progress.");
            }
            else {
                UI_1.UI.showErrorToast("No repositories selected for deletion.");
            }
            for (let i = 0; i < selected.length; i++) {
                const sel = selected[i];
                try {
                    yield this.deleteRepository(sel);
                    Log_1.default.info("AdminDeletePage::deleteRepoPressed(..) - delete complete; repo: " + sel);
                    UI_1.UI.showSuccessToast("Repository deleted: " + sel + " ( " + (i + 1) + " of " + selected.length + " )", {
                        force: true,
                        animation: "none",
                    });
                }
                catch (err) {
                    Log_1.default.error("AdminDeletePage::deleteRepoPressed(..) - delete pressed ERROR: " + err.message);
                    UI_1.UI.showErrorToast("Repository NOT deleted: " + sel);
                }
            }
            Log_1.default.info("AdminDeletePage::deleteRepoPressed(..) - done");
            if (selected.length > 0) {
                UI_1.UI.showSuccessToast("Repository deletion complete.", { buttonLabel: "Ok" });
            }
            yield this.init({});
        });
    }
    deleteDeliverablesPressed() {
        return __awaiter(this, void 0, void 0, function* () {
            const delivDelete = document.getElementById("deliverableDeleteSelect");
            const selected = [];
            for (const opt of delivDelete.options) {
                if (opt.selected) {
                    selected.push(opt.value || opt.text);
                }
            }
            Log_1.default.info("AdminDeletePage::deleteDeliverablesPressed(..) - start; # deliverables to delete: " + selected.length);
            if (selected.length === 0) {
                UI_1.UI.showErrorToast("No deliverables selected for deletion.");
                return;
            }
            for (let i = 0; i < selected.length; i++) {
                const sel = selected[i];
                try {
                    yield this.deleteDeliverable(sel);
                    Log_1.default.info("AdminDeletePage::deleteDeliverablesPressed(..) - delete complete; deliverable: " + sel);
                    UI_1.UI.showSuccessToast("Deliverable deleted: " + sel + " ( " + (i + 1) + " of " + selected.length + " )", {
                        force: true,
                        animation: "none",
                    });
                }
                catch (err) {
                    Log_1.default.error("AdminDeletePage::deleteDeliverablesPressed(..) - ERROR: " + err.message);
                    UI_1.UI.showErrorToast("Deliverable NOT deleted: " + sel);
                }
            }
            Log_1.default.info("AdminDeletePage::deleteDeliverablesPressed(..) - done");
            UI_1.UI.showSuccessToast("Deliverable deletion complete.", { buttonLabel: "Ok" });
            yield this.init({});
        });
    }
    deleteTeamPressed() {
        return __awaiter(this, void 0, void 0, function* () {
            const teamDelete = document.getElementById("teamDeleteSelect");
            const selected = [];
            for (const opt of teamDelete.options) {
                if (opt.selected) {
                    selected.push(opt.value || opt.text);
                }
            }
            Log_1.default.info("AdminDeletePage::deleteTeamPressed(..) - start; # teams to delete: " + selected.length);
            if (selected.length > 0) {
                UI_1.UI.showSuccessToast("Team deletion in progress.");
            }
            else {
                UI_1.UI.showErrorToast("No teams selected for deletion.");
            }
            for (let i = 0; i < selected.length; i++) {
                const sel = selected[i];
                try {
                    yield this.deleteTeam(sel);
                    Log_1.default.info("AdminDeletePage::deleteTeamPressed(..) - delete complete; team: " + sel);
                    UI_1.UI.showSuccessToast("Team deleted: " + sel + " ( " + (i + 1) + " of " + selected.length + " )", {
                        force: true,
                        animation: "none",
                    });
                }
                catch (err) {
                    Log_1.default.error("AdminDeletePage::deleteTeamPressed(..) - delete pressed ERROR: " + err.message);
                    UI_1.UI.showErrorToast("Team NOT deleted: " + sel);
                }
            }
            Log_1.default.info("AdminDeletePage::deleteTeamPressed(..) - done");
            if (selected.length > 0) {
                UI_1.UI.showSuccessToast("Team deletion complete.", { buttonLabel: "Ok" });
            }
            yield this.init({});
        });
    }
    sanitizeDBPressed() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            var _b;
            const dryRun = document.getElementById("adminDeleteSanitizeDBToggle");
            Log_1.default.info("AdminDeletePage::sanitizeDBPressed(..) - start; dryRun: " + dryRun.checked);
            try {
                const url = this.remote + "/portal/admin/checkDatabase/" + (dryRun.checked === true);
                const options = AdminView_1.AdminView.getOptions();
                options.method = "post";
                const response = yield fetch(url, options);
                const body = yield response.json();
                if (typeof body.success === "undefined") {
                    throw new Error((_b = (_a = body === null || body === void 0 ? void 0 : body.failure) === null || _a === void 0 ? void 0 : _a.message) !== null && _b !== void 0 ? _b : "HTTP " + response.status);
                }
                Log_1.default.info("AdminDeletePage::sanitizeDBPressed(..) - done");
                if (dryRun.checked === true) {
                    UI_1.UI.showSuccessToast("Dry run complete: nothing was written. Repairs are in the portal log; turn Dry Run off to apply them.", {
                        buttonLabel: "Ok",
                        timeout: 8000,
                    });
                }
                else {
                    UI_1.UI.showSuccessToast("GitHub synchronization complete; the database now matches GitHub.", { buttonLabel: "Ok", timeout: 5000 });
                }
            }
            catch (err) {
                Log_1.default.error("AdminDeletePage::sanitizeDBPressed(..) - ERROR: " + err.message);
                UI_1.UI.showErrorToast("Error sanitizing DB: " + err.message);
            }
        });
    }
    renderPage(pageName, opts) {
        Log_1.default.info("AdminDeletePage::renderPage( " + pageName + ", ... ) - start");
    }
    deleteDeliverable(delivId) {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.info("AdminDeletePage::deleteDeliverable( " + delivId + " ) - start");
            const url = this.remote + "/portal/admin/deliverable/" + delivId;
            return yield this.performDelete(url);
        });
    }
    deleteTeam(teamId) {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.info("AdminDeletePage::deleteTeam( " + teamId + " ) - start");
            const url = this.remote + "/portal/admin/team/" + teamId;
            return yield this.performDelete(url);
        });
    }
    deleteRepository(repositoryId) {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.info("AdminDeletePage::deleteRepository( " + repositoryId + " ) - start");
            const url = this.remote + "/portal/admin/repository/" + repositoryId;
            return yield this.performDelete(url);
        });
    }
    performDelete(url) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            var _b;
            const options = AdminView_1.AdminView.getOptions();
            options.method = "delete";
            const response = yield fetch(url, options);
            const body = yield response.json();
            if (typeof body.success !== "undefined") {
                return true;
            }
            const message = (_b = (_a = body === null || body === void 0 ? void 0 : body.failure) === null || _a === void 0 ? void 0 : _a.message) !== null && _b !== void 0 ? _b : "HTTP " + response.status;
            Log_1.default.error("AdminDeletePage::performDelete( " + url + " ) - ERROR: " + message);
            throw new Error(message);
        });
    }
}
exports.AdminDeletePage = AdminDeletePage;
